import { render, staticRenderFns } from "./trainOrderInfo.vue?vue&type=template&id=07643774&"
import script from "./trainOrderInfo.vue?vue&type=script&lang=ts&"
export * from "./trainOrderInfo.vue?vue&type=script&lang=ts&"
import style0 from "./trainOrderInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports